// 为每个淘宝表单控件提供vuex中的淘宝的一些方法
import { mapGetters, mapActions } from 'vuex'
import { getItemPublishSchemaProp } from '@/servers/prod/center/tb';

export default {
  inject: ['tbFormVm'],
  data() {
    return {
      options: [],
      isAsyncOptions: false,
      secondaryName: '', // 当前控件的name
    }
  },
  computed: {
    ...mapGetters(['tbForm', 'tbData', 'tbOptions', 'tbFindOption', 'shops_defaultShopId', 'shops_updateShopId', 'shops_updateIndex', 'shops_all', 'shops_getCategoryPropShopId', 'removePureItem']),
    key() {
      return this.props.name
    },
  },
  watch: {
    props: {
      immediate: true,
      handler: function (v) {
        if (!v || !v.dataSource) return;
        const { options, name, label, parentName } = v.dataSource;
        let shopId = null;

        if (options && options.length) {
          this.asyncOptionsHandle(options)
        } else if (this.isHasOptionsComp) {
          // 需要选项的组件 调用接口请求选项列表
          shopId = parentName === 'catProp' ? this.shops_getCategoryPropShopId('tb')
            : this.shops_defaultShopId('tb')
          getItemPublishSchemaProp({
            shopId,
            baseItemId: '',
            catId: this.tbFormVm.categoryId,
            propId: name.replace('p-', '')
          }).then(res => {
            if (!res) return;
            this.asyncOptionsHandle(res.options)
          })
        }
      }
    }
  },
  methods: {
    ...mapActions(['initTbForm', 'updateTbForm', 'initTbOptions', 'updateTbSecondaryUIType']),
    asyncOptionsHandle(options) {
      options = options || []
      const { name, label } = this.props.dataSource;
      if (options?.length < 100) {
        this.options = (options || []).map(item => ({ ...item, pLabel: label }))
        this.isAsyncOptions = false
        return
      }
      // 待优化成分页
      // 现在数据量过大导致页面卡顿
      // 目前只取前99条
      const allOptions = options.map(item => ({ ...item, pLabel: label }))
      const optionList = allOptions.slice(0, 99)
      if(this._value instanceof Array) {
        this._value.forEach(_v => {
          const _valueIndex = allOptions.findIndex(item => item.value === _v);
          if (_valueIndex > 99) {
            optionList.unshift(allOptions.find(item => item.value === _v))
          }
        })
      } else {
        const _valueIndex = allOptions.findIndex(item => item.value === this._value);
        if (_valueIndex > 99) {
          optionList.unshift(allOptions.find(item => item.value === this._value))
        }
         
      }

      this.options = optionList;
      this.initTbOptions({ key: name, options: allOptions })
      this.checkOptionsValue && this.checkOptionsValue([], true);
      this.isAsyncOptions = true

    }
  },
}

